"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function WhiteSpace() {
    return '\u00A0';
});
